import {
  Badge,
  Box,
  Card,
  Divider,
  Heading,
  IconLink,
  IconMail,
  IconMessage,
  IconPhone,
  Link,
  Spread,
  Stack,
  Tag,
  Text,
} from 'braid-design-system';

import { formatPostedDate } from '#shared/formatPostedDate';
import type { PublishedListing } from '#shared/types';

interface ListingCardProps {
  listing: PublishedListing;
}

export const ListingCard = ({ listing }: ListingCardProps) => (
  <Card>
    <Spread direction="horizontal" space="small" alignY="top">
      <Stack space="medium">
        {listing.imageUrl ? (
          <Box
            style={{
              width: '100%',
              maxHeight: '200px',
              overflow: 'hidden',
              borderRadius: '8px',
            }}
          >
            <img
              src={listing.imageUrl}
              alt=""
              style={{ width: '100%', objectFit: 'cover' }}
            />
          </Box>
        ) : null}
        <Stack space="medium">
          <Heading level="4">{listing.name ?? 'Community member'}</Heading>
          {listing.serviceType ? (
            <Badge tone="info">{listing.serviceType}</Badge>
          ) : null}
          {listing.blurb ? <Text maxLines={4}>{listing.blurb}</Text> : null}
          <Divider />
          <Stack space="xsmall">
            {listing.phone ? (
              <Text icon={<IconPhone />}>
                <Link href={`tel:${listing.phone}`}>{listing.phone}</Link>
              </Text>
            ) : null}
            {listing.email ? (
              <Text icon={<IconMail />}>
                <Link href={`mailto:${listing.email}`}>{listing.email}</Link>
              </Text>
            ) : null}
            {listing.website ? (
              <Text icon={<IconLink />}>
                <Link href={listing.website} target="_blank">
                  {listing.website.replace(/^https?:\/\//, '')}
                </Link>
              </Text>
            ) : null}
          </Stack>
        </Stack>
      </Stack>
      {listing.postedAt ? (
        <Tag size="small">{formatPostedDate(listing.postedAt)}</Tag>
      ) : null}
    </Spread>
  </Card>
);
